import jwt_decode from "jwt-decode"
import models from '../../routes/models'
import {
    extractCloudinaryPublicId,
    getRadioCloudinaryCredentials,
} from './cloudinaryCredentials'

function destroyImageFromCloudinary(url, key, credentials) {
    const publicId = extractCloudinaryPublicId(url)
    if (!publicId) {
        return Promise.reject(new Error("Não foi possível gerar o id publico para remover a imagem"))
    }

    const token = localStorage.getItem("APP_01")
    const radioKey = key || (token && jwt_decode(token).radio.key)
    const creds = getRadioCloudinaryCredentials(credentials)

    return models().post('services/destroyImage', {
        key: radioKey,
        public_id: publicId,
        ...creds,
    })
}

export default destroyImageFromCloudinary
